//import { find, propEq, prop, pick, defaultTo } from "ramda";
import { prop, defaultTo } from "ramda";

export const initialModelState = {
  modelMeta: {
    name: "New Model",
    purpose: "",
  },
  ebes: [],
  gens: [],
  pad1: {},
  pad2: {},
  rads: [],
  roles: [], // Generally visible roles
};

export const modelReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_MODEL_PART": {
      const { partKey, value } = action.payload;
      return {
        ...state,
        [partKey]: value,
      };
    }
    case "BATCH_UPDATE_MODEL": {
      const { updates } = action.payload; // e.g., [{ partKey: 'ebes', value: [...] }, { partKey: 'gens', value: [...] }]
      return updates.reduce((newState, { partKey, value }) => {
        return { ...newState, [partKey]: value };
      }, state);
    }
    case "UPDATE_MODEL":
    case "CHANGE_MODEL":
      return {
        ...action.payload, // payload is the entire model
      };
    case "RESET_MODEL":
      return {
        ...initialModelState,
      };
    default:
      return state;
  }
};

// Query functions for Model
// These are as dumb as possible as the internals of the
// various objects are handled in the relevant components.

export const getModelMeta = prop("modelMeta");
export const getEBEs = prop("ebes");
export const getGenerators = prop("gens");
export const getPAD = (padKey) => (model) => defaultTo({}, prop(padKey, model));
export const getRADs = prop("rads");
export const getRoles = prop("roles");

// Abstract rad update function
export const updateRADs = (rads) => ({
  type: "UPDATE_MODEL_PART",
  payload: { partKey: "rads", value: rads },
});
